export default __webpack_public_path__ + "static/media/newLead50.9ab3f8e5.png";